import {
  GET_USERS_SUCCESS,
  GET_USERS_FAIL,
  ADD_USER_SUCCESS,
  ADD_USER_FAIL,
  UPDATE_USER_SUCCESS,
  UPDATE_USER_FAIL,
  DELETE_USER_SUCCESS,
  DELETE_USER_FAIL,
  GET_USER_PROFILE_SUCCESS,
  GET_USER_PROFILE_FAIL,
  GET_REFERANCES_SUCCESS,
  GET_WORKSHOP2_SUCCESS,
  GET_POPUP_SUCCESS,
  UPDATE_POPUP_SUCCESS,
  UPDATE_SUBDOMAIN_SUCCESS,
  UPDATE_SUCCESS_COURSESCHEDULES,
  UPDATE_WORKSHOPSESSION_SUCCESS,
  UPDATE_SUCCESS_TEACHER,
  UPDATE_CONTACT_SUCCESS,
  UPDATE_ABOUT_SUCCESS,
  UPDATE_SUCCESS_NEWS,
  UPDATE_SUCCESS_MEGA,
  UPDATE_WORKSHOP2_SUCCESS,
  UPDATE_SUCCESS_GALLERY,

  GET_WORKSHOP_SUCCESS,
  GET_WORKSHOPSESSION_SUCCESS,
  GET_APPLICATION_SUCCESS,
  GET_SLIDER_SUCCESS,
  GET_PROJECTS_SUCCESS,
  GET_NEWS_SUCCESS,
  GET_MEGA_SUCCESS,
  GET_TEACHER_SUCCESS,
  GET_DYNAMIC_SUCCESS,
  GET_CONTACT,
  GET_ABOUT,
  GET_AUTH_SUCCESS,
  GET_AUTHUPDATE_SUCCESS,
  UPDATE_SUCCESS_PROJECT,
  GET_GALLERY_SUCCESS,
  ADD_REFERANCES_SUCCESS,
  UPDATE_REFERANCES_SUCCESS,
  GET_SUBPROJECT_SUCCESS,
  GET_TEACHERWORKSHOP_SUCCESS,
  ADD_LESSONSTIME_SUCCESS,
  UPDATE_LESSONSTIME_SUCCESS,
  GET_CLASSATTENDANCE_SUCCESS,

  GET_CLASSES_SUCCESS,
  UPDATE_DYNAMICFORM_SUCCESS,
  ADD_DYNAMICFORM_SUCCESS,
  GET_DYNAMICFORMEXTRA_SUCCESS,
  GET_DYNAMICFORMEXTRAEXTRA_SUCCESS,
  ADD_MEGA_SUCCESS,
  DELETE_MEGA_SUCCESS,
  DELETE_NEWS_SUCCESS,
  DELETE_SLIDER_SUCCESS,
  DELETE_POPUP_SUCCESS,
  DELETE_REFERANCES_SUCCESS,
  ADD_GALLERY_SUCCESS,
  DELETE_PRODUCTCATEGORY_SUCCESS,
  DELETE_GALLERY_SUCCESS,
  DELETE_COURSESCHEDULES_SUCCESS,
  DELETE_DYNAMICFORMEXTRA_SUCCESS,
  DELETE_DYNAMICFORM_SUCCESS,

  DELETE_RESERVATION_SUCCESS,
  GET_RESERVATION_SUCCESS,
  UPDATE_RESERVATION_SUCCESS,
  ADD_RESERVATION_SUCCESS,




  DELETE_AVAILABLE_SUCCESS,
  GET_AVAILABLE_SUCCESS,
  UPDATE_AVAILABLE_SUCCESS,
  ADD_AVAILABLE_SUCCESS,

  DELETE_OFFER_SUCCESS,
  GET_OFFER_SUCCESS,
  UPDATE_OFFER_SUCCESS,
  ADD_OFFER_SUCCESS,

  DELETE_DYNAMICFORMEXTRAEXTRA_SUCCESS,
  GET_EDUCATION_SUCCESS,
  GET_SUBEDUCATION_SUCCESS,
  UPDATE_EDUCATION_SUCCESS,
  UPDATE_PRODUCTCATEGORY_SUCCESS,
  ADD_EDUCATION_SUCCESS,
  ADD_SUBEDUCATION_SUCCESS,
  ADD_SLIDER_SUCCES,
  DELETE_SUBEDUCATION_SUCCESS,
  UPDATE_SUBEDUCATION_SUCCESS,
  UPDATE_SLIDER_SUCCESS,
  UPDATE_BLOG_SUCCESS,
  GET_PRODUCTCATEGORY_SUCCESS,
  GET_PRODUCT_SUCCESS,
  GET_SLİDERS_SUCCESS,
  GET_BLOGS_SUCCESS,
  ADD_BLOG_SUCCESS,
  ADD_PRODUCTCATEGORY_SUCCESS,
  DELETE_BLOG_SUCCESS,
  ADD_PRODUCT_SUCCESS,
  DELETE_PRODUCT_SUCCESS,
  UPDATE_PRODUCT_SUCCESS,
  GET_ABOUT_SUCCESS,
  ADD_SSS_SUCCESS,
  DELETE_SSS_SUCCESS,
  UPDATE_SSS_SUCCESS,
  GET_SSS_SUCCESS,
  ADD_ADVERT_SUCCESS,
  DELETE_ADVERT_SUCCESS,
  UPDATE_ADVERT_SUCCESS,
  GET_ADVERT_SUCCESS,
  GET_PRODUCTSUBCATEGORY_SUCCESS,
  GET_BRAND_SUCCESS,
  UPDATE_BRAND_SUCCESS,
  GET_PRODUCTSUBSUBCATEGORY_SUCCESS,
  ADD_SUBSUBCATEGORY_SUCCESS,
  UPDATE_SUBSUBCATEGORY_SUCCESS,
  ADD_BRAND_SUCCESS,
  ADD_SUBCATEGORY_SUCCESS,
  ADD_POPUP_SUCCESS,
  DELETE_PRODUCTSUBCATEGORY_SUCCESS,
  DELETE_SUBSUBCATEGORY_SUCCESS,
  DELETE_LIMIT_SUCCESS,
  UPDATE_LIMIT_SUCCESS,
  ADD_LIMIT_SUCCESS,
  GET_LIMIT_SUCCESS,
  ADD_SLIDER_SUCCESS,
  UPDATE_PRODUCTSUBCATEGORY_SUCCESS,
  GET_PDR_SUCCESS,
  UPDATE_PDR_SUCCESS,
  ADD_PDR_SUCCESS,
  DELETE_PDR_SUCCESS,
  ADD_SONG_SUCCESS,
  UPDATE_SONG_SUCCESS,
  DELETE_SONG_SUCCESS,
  GET_SONG_SUCCESS,
  ADD_SONG_CATEGORY_SUCCESS,
  GET_SONG_CATEGORY_SUCCESS,
  UPDATE_SONG_CATEGORY_SUCCESS,
  DELETE_SONG_CATEGORY_SUCCESS,
  GET_POST_SUCCESS,
  DELETE_POST_SUCCESS,
  UPDATE_POST_SUCCESS,
  UPDATE_MOTIVATION_SUCCESS,
  ADD_MOTIVATION_SUCCESS,
  GET_MOTIVATION_SUCCESS,
  DELETE_MOTIVATION_SUCCESS,
  GET_BOOK_SUCCESS,
  DELETE_BOOK_SUCCESS,
  UPDATE_BOOK_SUCCESS,
  ADD_BOOK_SUCCESS,
  GET_COUNTER_SUCCESS,
  DELETE_COUNTER_SUCCESS,
  UPDATE_COUNTER_SUCCESS,
  ADD_COUNTER_SUCCESS,
  GET_SALES_POINTSUCCESS,
  DELETE_SALES_POINTSUCCESS,
  UPDATE_SALES_POINTSUCCESS,
  ADD_SALES_POINTSUCCESS,
  UPDATE_COACHSUCCESS,
  ADD_COACHSUCCESS,
  GET_COACHSUCCESS,
  DELETE_COACHSUCCESS,
  DELETE_PURCH_SUCCESS,
  UPDATE_PURCH_SUCCESS,
  ADD_PURCH_SUCCESS,
  GET_PURCH_SUCCESS,
  GET_SCHOOL_SUCCESS,
  DELETE_SCHOOL_SUCCESS,
  ADD_SCHOOL_SUCCESS,
  UPDATE_SCHOOL_SUCCESS,
  GET_TEACHERSCHOOL_SUCCESS,
  GET_STUDENT_SUCCESS,
  GET_USERSWEB_SUCCESS,

} from "./actionTypes"

const INIT_STATE = {
  forum: [],
  users: [],
  userProfile: {},
  error: {},
  popup: [],
  workshop: [],
  workshopSession: [],
  workshopsessionMega: [],
  slider: [],
  projects: [],
  news: [],
  mega: [],
  teacher: [],
  dynamic: [],
  contact: [],
  authlist: [],
  workshop2: [],
  gallery: [],
  referances: [],
  subProject: [],
  lessonstime: [],
  classattendance: [],
  classes: [],

  dynamicformextra: [],
  dynamicformextraextra: [],
  education: [],
  educationSubItem: [],

  productCategory: [],
  products: [],
  sliders: [],
  blogs: [],
  about: [],
  sss: [],
  reservation: [],
  offer: [],
  available: [],
  advert: [],

  productSubCategory: [],
  brand:[],
  productSubSubCategory:[],

  limit:[],
  pdr:[],
  song:[],
  songcategory:[],
  motivation:[],
  book:[],
  counter:[],
  salesPoint:[],
  coachPost:[],
  purch:[],
  school:[],
  schoolUser:[],
  studentUser:[],
  usersWeb:[]
}

const contacts = (state = INIT_STATE, action) => {
  switch (action.type) {
    case ADD_SCHOOL_SUCCESS:
      return {
        ...state,
        school: [...state.school, action.payload],
      }
      
      case GET_STUDENT_SUCCESS:
        return {
          ...state,
          studentUser: action.payload,
        }

      case GET_TEACHERSCHOOL_SUCCESS:
        return {
          ...state,
          schoolUser: action.payload,
        }
  
    
    case GET_SCHOOL_SUCCESS:
      return {
        ...state,
        school: action.payload,
      }


    case UPDATE_SCHOOL_SUCCESS:
      return {
        ...state,
        school: state.school.map(x =>
          x.ID.toString() === action.payload.ID.toString()
            ? { x, ...action.payload }
            : x
        ),
      }

    case DELETE_SCHOOL_SUCCESS:
      return {
        ...state,
        school: state.purch.filter(
          school => user.ID.toString() !== action.payload.toString()
        ),
      }

    case DELETE_PURCH_SUCCESS:
      return {
        ...state,
        purch: state.purch.filter(
          user => user.ID.toString() !== action.payload.toString()
        ),
      }


    case UPDATE_PURCH_SUCCESS:
      return {
        ...state,
        purch: state.purch.map(x =>
          x.ID.toString() === action.payload.ID.toString()
            ? { x, ...action.payload }
            : x
        ),
      }

    case ADD_PURCH_SUCCESS:
      return {
        ...state,
        purch: [...state.purch, action.payload],
      }


    case GET_PURCH_SUCCESS:
      return {
        ...state,
        purch: action.payload,
      }


    case DELETE_COACHSUCCESS:
      return {
        ...state,
        coachPost: state.coachPost.filter(
          user => user.ID.toString() !== action.payload.toString()
        ),
      }


    case UPDATE_COACHSUCCESS:
      return {
        ...state,
        coachPost: state.coachPost.map(x =>
          x.ID.toString() === action.payload.ID.toString()
            ? { x, ...action.payload }
            : x
        ),
      }

    case ADD_COACHSUCCESS:
      return {
        ...state,
        coachPost: [...state.coachPost, action.payload],
      }


    case GET_COACHSUCCESS:
      return {
        ...state,
        coachPost: action.payload,
      }

    case DELETE_LIMIT_SUCCESS:
      return {
        ...state,
        limit: state.limit.filter(
          user => user.ID.toString() !== action.payload.toString()
        ),
      }


    case UPDATE_LIMIT_SUCCESS:
      return {
        ...state,
        limit: state.limit.map(x =>
          x.ID.toString() === action.payload.ID.toString()
            ? { x, ...action.payload }
            : x
        ),
      }

    case ADD_LIMIT_SUCCESS:
      return {
        ...state,
        limit: [...state.limit, action.payload],
      }


    case GET_LIMIT_SUCCESS:
      return {
        ...state,
        limit: action.payload,
      }

    case DELETE_ADVERT_SUCCESS:
      return {
        ...state,
        advert: state.advert.filter(
          user => user.ID.toString() !== action.ID.toString()
        ),
      }


    case UPDATE_ADVERT_SUCCESS:
      return {
        ...state,
        advert: state.advert.map(x =>
          x.ID.toString() === action.payload.ID.toString()
            ? { x, ...action.payload }
            : x
        ),
      }

    case ADD_ADVERT_SUCCESS:
      return {
        ...state,
        advert: [...state.advert, action.payload],
      }


    case GET_ADVERT_SUCCESS:
      return {
        ...state,
        advert: action.payload,
      }



    case DELETE_OFFER_SUCCESS:
      return {
        ...state,
        offer: state.offer.filter(
          user => user.ID.toString() !== action.ID.toString()
        ),
      }


    case UPDATE_OFFER_SUCCESS:
      return {
        ...state,
        offer: state.offer.map(x =>
          x.ID.toString() === action.payload.ID.toString()
            ? { x, ...action.payload }
            : x
        ),
      }

    case ADD_OFFER_SUCCESS:
      return {
        ...state,
        offer: [...state.offer, action.payload],
      }


    case GET_OFFER_SUCCESS:
      return {
        ...state,
        offer: action.payload,
      }



      case DELETE_AVAILABLE_SUCCESS:
        return {
          ...state,
          available: state.available.filter(
            user => user.ID.toString() !== action.payload.toString()
          ),
        }
  
  
      case UPDATE_AVAILABLE_SUCCESS:
        return {
          ...state,
          available: state.available.map(x =>
            x.ID.toString() === action.payload.ID.toString()
              ? { x, ...action.payload }
              : x
          ),
        }
  
      case ADD_AVAILABLE_SUCCESS:
        return {
          ...state,
          available: [...state.available, action.payload],
        }
  
  
      case GET_AVAILABLE_SUCCESS:
        return {
          ...state,
          available: action.payload,
        }



    case DELETE_RESERVATION_SUCCESS:
      return {
        ...state,
        reservation: state.reservation.filter(
          user => user.ID.toString() !== action.payload.toString()
        ),
      }



    case UPDATE_RESERVATION_SUCCESS:
      return {
        ...state,
        reservation: state.reservation.map(x =>
          x.ID.toString() === action.payload.ID.toString()
            ? { x, ...action.payload }
            : x
        ),
      }

    case ADD_RESERVATION_SUCCESS:
      return {
        ...state,
        reservation: [...state.reservation, action.payload],
      }


    case GET_RESERVATION_SUCCESS:
      return {
        ...state,
        reservation: action.payload,
      }


      

      case DELETE_SUBSUBCATEGORY_SUCCESS:
        return {
          ...state,
          productSubSubCategory: state.productSubSubCategory.filter(
            user => user.ID.toString() !== action.payload.toString()
          ),
        }


      case DELETE_PRODUCTSUBCATEGORY_SUCCESS:
        return {
          ...state,
          productSubCategory: state.productSubCategory.filter(
            user => user.ID.toString() !== action.payload.toString()
          ),
        }

        
    case DELETE_DYNAMICFORMEXTRAEXTRA_SUCCESS:
      return {
        ...state,
        dynamicformextraextra: state.dynamicformextraextra.filter(
          user => user.ID.toString() !== action.ID.toString()
        ),
      }

    case DELETE_DYNAMICFORM_SUCCESS:
      return {
        ...state,
        dynamic: state.dynamic.filter(
          user => user.ID.toString() !== action.ID.toString()
        ),
      }

    case DELETE_DYNAMICFORMEXTRA_SUCCESS:
      return {
        ...state,
        dynamicformextra: state.dynamicformextra.filter(
          user => user.ID.toString() !== action.ID.toString()
        ),
      }


    case UPDATE_EDUCATION_SUCCESS:
      return {
        ...state,
        education: state.education.map(x =>
          x.ID.toString() === action.payload.ID.toString()
            ? { x, ...action.payload }
            : x
        ),
      }


    case UPDATE_PRODUCTCATEGORY_SUCCESS:
      return {
        ...state,
        productCategory: state.productCategory.map(x =>
          x.ID.toString() === action.payload.ID.toString()
            ? { x, ...action.payload }
            : x
        ),
      }


    case UPDATE_PRODUCT_SUCCESS:
      return {
        ...state,
        products: state.products.map(x =>
          x.ID.toString() === action.payload.ID.toString()
            ? { x, ...action.payload }
            : x
        ),
      }


    case DELETE_PRODUCT_SUCCESS:
      return {
        ...state,
        products: state.products.filter(
          user => user.ID.toString() !== action.payload.toString()
        ),
      }


    case DELETE_BLOG_SUCCESS:
      return {
        ...state,
        blogs: state.blogs.filter(
          user => user.ID.toString() !== action.payload.toString()
        ),
      }


    case UPDATE_BLOG_SUCCESS:
      return {
        ...state,
        blogs: state.blogs.map(x =>
          x.ID.toString() === action.payload.ID.toString()
            ? { x, ...action.payload }
            : x
        ),
      }
    case UPDATE_ABOUT_SUCCESS:
      return {
        ...state,
        about: state.about.map(x =>
          x.ID.toString() === action.payload.ID.toString()
            ? { x, ...action.payload }
            : x
        ),
      }

    case UPDATE_USER_SUCCESS:
      return {
        ...state,
        users: state.users.map(x =>
          x.ID.toString() === action.payload.ID.toString()
            ? { x, ...action.payload }
            : x
        ),
      }

    case UPDATE_DYNAMICFORM_SUCCESS:
      return {
        ...state,
        dynamic: state.dynamic.map(x =>
          x.ID == action.payload.ID
            ? { x, ...action.payload }
            : x
        ),
      }


    case DELETE_USER_SUCCESS:
      return {
        ...state,
        users: state.users.filter(
          forum => forum.ID.toString() !== action.payload.toString()
        ),
      }

    case DELETE_COURSESCHEDULES_SUCCESS:
      return {
        ...state,
        workshopSession: state.workshopSession.filter(
          user => user.ID.toString() !== action.ID.toString()
        ),
      }

    case DELETE_GALLERY_SUCCESS:
      return {
        ...state,
        gallery: state.gallery.filter(
          user => user.ID.toString() !== action.ID.toString()
        ),
      }

    case DELETE_PRODUCTCATEGORY_SUCCESS:
      return {
        ...state,
        productCategory: state.productCategory.filter(
          user => user.ID.toString() !== action.payload.toString()
        ),
      }
    case UPDATE_SUBEDUCATION_SUCCESS:
      return {
        ...state,
        educationSubItem: state.dynamic.map(x =>
          x.ID == action.educationSubItem.ID
            ? { x, ...action.payload }
            : x
        ),
      }

      
      case GET_USERSWEB_SUCCESS:
        return {
          ...state,
          usersWeb: action.payload,
        }

      case GET_SALES_POINTSUCCESS:
        return {
          ...state,
          salesPoint: action.payload,
        }


        case DELETE_SALES_POINTSUCCESS:
          return {
            ...state,
            salesPoint: state.salesPoint.filter(
              user => user.ID.toString() !== action.payload.toString()
            ),
          }
    
          
          case UPDATE_SALES_POINTSUCCESS:
            return {
              ...state,
              salesPoint: state.salesPoint.map(x =>
                x.ID == action.payload.ID
                  ? { x, ...action.payload }
                  : x
              ),
            }

                  
      case ADD_SALES_POINTSUCCESS:
        return {
          ...state,
          salesPoint: [...state.salesPoint, action.payload],
        }


      case GET_COUNTER_SUCCESS:
        return {
          ...state,
          counter: action.payload,
        }


        case DELETE_COUNTER_SUCCESS:
          return {
            ...state,
            counter: state.counter.filter(
              user => user.ID.toString() !== action.payload.toString()
            ),
          }
    
          
          case UPDATE_COUNTER_SUCCESS:
            return {
              ...state,
              counter: state.counter.map(x =>
                x.ID == action.payload.ID
                  ? { x, ...action.payload }
                  : x
              ),
            }

                  
      case ADD_COUNTER_SUCCESS:
        return {
          ...state,
          counter: [...state.counter, action.payload],
        }



      case GET_BOOK_SUCCESS:
        return {
          ...state,
          book: action.payload,
        }


        case DELETE_BOOK_SUCCESS:
          return {
            ...state,
            book: state.book.filter(
              user => user.ID.toString() !== action.payload.toString()
            ),
          }
    
          
          case UPDATE_BOOK_SUCCESS:
            return {
              ...state,
              book: state.book.map(x =>
                x.ID == action.payload.ID
                  ? { x, ...action.payload }
                  : x
              ),
            }

                  
      case ADD_BOOK_SUCCESS:
        return {
          ...state,
          book: [...state.book, action.payload],
        }

    case DELETE_SUBEDUCATION_SUCCESS:
      return {
        ...state,
        educationSubItem: state.educationSubItem.filter(
          user => user.ID.toString() !== action.payload.toString()
        ),
      }

      
      case UPDATE_PRODUCTSUBCATEGORY_SUCCESS:
        return {
          ...state,
          productSubCategory: state.productSubCategory.map(x =>
            x.ID == action.payload.ID
              ? { x, ...action.payload }
              : x
          ),
        }

      case UPDATE_SUBEDUCATION_SUCCESS:
        return {
          ...state,
          productSubCategory: state.productSubCategory.map(x =>
            x.ID == action.payload.ID
              ? { x, ...action.payload }
              : x
          ),
        }
      
      case ADD_SUBCATEGORY_SUCCESS:
        return {
          ...state,
          productSubCategory: [...state.productSubCategory, action.payload],
        }

    case ADD_SUBEDUCATION_SUCCESS:
      return {
        ...state,
        educationSubItem: [...state.educationSubItem, action.payload],
      }


    case ADD_SLIDER_SUCCESS:
      return {
        ...state,
        sliders: [...state.sliders, action.payload],
      }

    case ADD_PRODUCT_SUCCESS:
      return {
        ...state,
        products: [...state.products, action.payload],
      }


    case ADD_EDUCATION_SUCCESS:
      return {
        ...state,
        education: [...state.education, action.payload],
      }

    case ADD_GALLERY_SUCCESS:
      return {
        ...state,
        gallery: [...state.gallery, action.payload],
      }

    case DELETE_REFERANCES_SUCCESS:
      return {
        ...state,
        referances: state.referances.filter(
          user => user.ID.toString() !== action.ID.toString()
        ),
      }

    case ADD_POPUP_SUCCESS:
      return {
        ...state,
        popup: [...state.popup, action.payload],
      }


    case UPDATE_POPUP_SUCCESS:
        return {
          ...state,
          popup: state.popup.map(x =>
            x.ID == action.payload.ID
              ? { x, ...action.payload }
              : x
          ),
        }

    case DELETE_POPUP_SUCCESS:
      return {
        ...state,
        popup: state.popup.filter(
          user => user.ID.toString() !== action.ID.toString()
        ),
      }

    case DELETE_SLIDER_SUCCESS:
      return {
        ...state,
        sliders: state.sliders.filter(
          user => user.ID.toString() !== action.ID.toString()
        ),
      }

    case DELETE_SSS_SUCCESS:
      return {
        ...state,
        sss: state.sss.filter(
          user => user.ID.toString() !== action.payload.toString()
        ),
      }

    case DELETE_NEWS_SUCCESS:
      return {
        ...state,
        news: state.news.filter(
          user => user.ID.toString() !== action.ID.toString()
        ),
      }

    case DELETE_MEGA_SUCCESS:
      return {
        ...state,
        mega: state.mega.filter(
          user => user.ID.toString() !== action.ID.toString()
        ),
      }


    case ADD_MEGA_SUCCESS:
      return {
        ...state,
        mega: [...state.mega, action.payload],
      }

      
        
      case GET_PDR_SUCCESS:
        return {
          ...state,
          pdr: action.payload,
        }

        
        
        case ADD_PDR_SUCCESS:
          return {
            ...state,
            pdr: [...state.pdr, action.payload],
          }

        case UPDATE_PDR_SUCCESS:
          return {
            ...state,
            pdr: state.pdr.map(x =>
              x.ID == action.payload.ID
                ? { x, ...action.payload }
                : x
            ),
          }
    
        
    case DELETE_PDR_SUCCESS:
      return {
        ...state,
        pdr: state.pdr.filter(
          user => user.ID.toString() !== action.payload.toString()
        ),
      }


      case GET_PRODUCTSUBCATEGORY_SUCCESS:
        return {
          ...state,
          productSubCategory: action.payload,
        }

    case GET_ABOUT_SUCCESS:
      return {
        ...state,
        about: action.payload,
      }
    case GET_SSS_SUCCESS:
      return {
        ...state,
        sss: action.payload,
      }


    case GET_SUBEDUCATION_SUCCESS:
      return {
        ...state,
        educationSubItem: action.payload,
      }

    case GET_PRODUCTCATEGORY_SUCCESS:
      return {
        ...state,
        productCategory: action.payload,
      }


    case GET_PRODUCT_SUCCESS:
      return {
        ...state,
        products: action.payload,
      }


    case GET_SLİDERS_SUCCESS:
      return {
        ...state,
        sliders: action.payload,
      }


    case GET_BLOGS_SUCCESS:
      return {
        ...state,
        blogs: action.payload,
      }
    case GET_EDUCATION_SUCCESS:
      return {
        ...state,
        education: action.payload,
      }

    case GET_DYNAMICFORMEXTRAEXTRA_SUCCESS:
      return {
        ...state,
        dynamicformextraextra: action.payload,
      }

    case GET_DYNAMICFORMEXTRA_SUCCESS:
      return {
        ...state,
        dynamicformextra: action.payload,
      }

    case UPDATE_DYNAMICFORM_SUCCESS:
      return {
        ...state,
        dynamic: state.dynamic.map(x =>
          x.ID == action.payload.ID
            ? { x, ...action.payload }
            : x
        ),
      }

    case GET_CLASSES_SUCCESS:
      return {
        ...state,
        classes: action.payload,
      }

    case GET_CLASSATTENDANCE_SUCCESS:
      return {
        ...state,
        classattendance: action.payload,
      }

    case UPDATE_LESSONSTIME_SUCCESS:
      return {
        ...state,
        lessonstime: state.lessonstime.map(x =>
          x.ID == action.payload.ID
            ? { x, ...action.payload }
            : x
        ),
      }

      case ADD_SONG_SUCCESS:
      return {
        ...state,
        song: [...state.song, action.payload],
      }
    case GET_SONG_SUCCESS:
      return {
        ...state,
        song: action.payload,
      }


    case UPDATE_SONG_SUCCESS:
      return {
        ...state,
        song: state.song.map(x =>
          x.ID == action.payload.ID
            ? { x, ...action.payload }
            : x
        ),
      }



    case ADD_SONG_CATEGORY_SUCCESS:
      return {
        ...state,
        songcategory: [...state.songcategory, action.payload],
      }
    case GET_SONG_CATEGORY_SUCCESS:
      return {
        ...state,
        songcategory: action.payload,
      }


    case UPDATE_SONG_CATEGORY_SUCCESS:
      return {
        ...state,
        songcategory: state.songcategory.map(x =>
          x.ID == action.payload.ID
            ? { x, ...action.payload }
            : x
        ),
      }
    case DELETE_SONG_CATEGORY_SUCCESS:
      return {
        ...state,
        songcategory: state.songcategory.filter(
          user => user.ID.toString() !== action.ID.toString()
        ),
      }
    case DELETE_SONG_SUCCESS:
      return {
        ...state,
        song: state.song.filter(
          user => user.ID.toString() !== action.ID.toString()
        ),
      }

    case ADD_DYNAMICFORM_SUCCESS:
      return {
        ...state,
        dynamic: [...state.dynamic, action.payload],
      }

    case ADD_SSS_SUCCESS:
      return {
        ...state,
        sss: [...state.sss, action.payload],
      }
    case ADD_LESSONSTIME_SUCCESS:
      return {
        ...state,
        lessonstime: [...state.lessonstime, action.payload],
      }

    case GET_TEACHERWORKSHOP_SUCCESS:
      return {
        ...state,
        lessonstime: action.payload,
      }


    case GET_SUBPROJECT_SUCCESS:
      return {
        ...state,
        subProject: action.payload,
      }

    case UPDATE_REFERANCES_SUCCESS:
      return {
        ...state,
        referances: state.referances.map(x =>
          x.ID == action.payload.ID
            ? { x, ...action.payload }
            : x
        ),
      }

    case UPDATE_SSS_SUCCESS:
      return {
        ...state,
        sss: state.sss.map(x =>
          x.ID == action.payload.ID
            ? { x, ...action.payload }
            : x
        ),
      }
    case GET_REFERANCES_SUCCESS:
      return {
        ...state,
        referances: action.payload,
      }

    case GET_AUTHUPDATE_SUCCESS:
      return {
        ...state,
        authlist: [],
      }

    case GET_AUTH_SUCCESS:
      return {
        ...state,
        authlist: action.payload,
      }


    case GET_WORKSHOP2_SUCCESS:
      return {
        ...state,
        workshop2: action.payload,
      }

    case GET_CONTACT:
      return {
        ...state,
        contact: action.payload,
      }



    case GET_DYNAMIC_SUCCESS:
      return {
        ...state,
        dynamic: action.payload,
      }



    case GET_MOTIVATION_SUCCESS:
      return {
        ...state,
        motivation: action.payload,
      }

      case UPDATE_MOTIVATION_SUCCESS:
  return {
    ...state,
    motivation: state.motivation.map(x =>
      x.ID.toString() === action.payload.ID.toString()
        ? { x, ...action.payload }
        : x
    ),
  }
      
  case ADD_MOTIVATION_SUCCESS:
    return {
      ...state,
      motivation: [...state.motivation, action.payload],
    }

    
    case DELETE_MOTIVATION_SUCCESS:
      return {
        ...state,
        motivation: state.motivation.filter(
          user => user.ID.toString() !== action.payload.toString()
        ),
      }

case DELETE_POST_SUCCESS:
  return {
    ...state,
    teacher: state.teacher.filter(
      user => user.ID.toString() !== action.ID.toString()
    ),
  }


case UPDATE_POST_SUCCESS:
  return {
    ...state,
    teacher: state.teacher.map(x =>
      x.ID.toString() === action.payload.ID.toString()
        ? { x, ...action.payload }
        : x
    ),
  }


      case GET_POST_SUCCESS:
      return {
        ...state,
        teacher: action.payload,
      }

    case GET_TEACHER_SUCCESS:
      return {
        ...state,
        teacher: action.payload,
      }
    case GET_MEGA_SUCCESS:
      return {
        ...state,
        mega: action.payload,
      }

    case GET_NEWS_SUCCESS:
      return {
        ...state,
        news: action.payload,
      }

    case GET_PROJECTS_SUCCESS:
      return {
        ...state,
        projects: action.payload,
      }

    case GET_SLIDER_SUCCESS:
      return {
        ...state,
        slider: action.payload,
      }
    case GET_APPLICATION_SUCCESS:
      return {
        ...state,
        workshopsessionMega: action.payload,
      }
    case GET_WORKSHOPSESSION_SUCCESS:
      return {
        ...state,
        workshopSession: action.payload,
      }
    case GET_WORKSHOP_SUCCESS:
      return {
        ...state,
        workshop: action.payload,
      }

    case GET_GALLERY_SUCCESS:
      return {
        ...state,
        gallery: action.payload,
      }


    case UPDATE_SUCCESS_GALLERY:
      console.log("deneme123", action.payload)
      return {
        ...state,
        gallery: state.gallery.map(x =>
          x.ID == action.payload.ID
            ? { x, ...action.payload }
            : x
        ),
      }


    case UPDATE_SUCCESS_MEGA:
      console.log("deneme123", action.payload)
      return {
        ...state,
        mega: state.mega.map(x =>
          x.ID == action.payload.ID
            ? { x, ...action.payload }
            : x
        ),
      }



    case UPDATE_WORKSHOP2_SUCCESS:
      return {
        ...state,
        workshop2: state.workshop2.map(x =>
          x.ID == action.payload.ID
            ? { x, ...action.payload }
            : x
        ),
      }

    case UPDATE_SUCCESS_NEWS:
      return {
        ...state,
        news: state.news.map(x =>
          x.ID == action.payload.ID
            ? { x, ...action.payload }
            : x
        ),
      }

    case UPDATE_CONTACT_SUCCESS:
      return {
        ...state,
        contact: state.contact.map(x =>
          x.ID == action.payload.ID
            ? { x, ...action.payload }
            : x
        ),
      }

    case UPDATE_SUCCESS_PROJECT:
      return {
        ...state,
        projects: state.projects.map(x =>
          x.ID == action.payload.ID
            ? { x, ...action.payload }
            : x
        ),
      }

    case UPDATE_SLIDER_SUCCESS:
      return {
        ...state,
        sliders: state.sliders.map(x =>
          x.ID == action.payload.ID
            ? { x, ...action.payload }
            : x
        ),
      }

    case UPDATE_SUBDOMAIN_SUCCESS:
      return {
        ...state,
        workshop: state.workshop.map(x =>
          x.ID == action.payload.ID
            ? { x, ...action.payload }
            : x
        ),
      }


    case UPDATE_SUCCESS_TEACHER:
      return {
        ...state,
        teacher: state.teacher.map(x =>
          x.ID == action.payload.ID
            ? { x, ...action.payload }
            : x
        ),
      }


    case UPDATE_WORKSHOPSESSION_SUCCESS:
      return {
        ...state,
        workshopsessionMega: state.workshopsessionMega.map(x =>
          x.ID == action.payload.ID
            ? { x, ...action.payload }
            : x
        ),
      }

    case UPDATE_SUCCESS_COURSESCHEDULES:
      console.log("lksdnfsd", state.workshopSession)
      return {
        ...state,
        workshopSession: state.workshopSession.map(x =>
          x.ID == action.payload.ID
            ? { x, ...action.payload }
            : x
        ),
      }



      case ADD_BRAND_SUCCESS:
        return {
          ...state,
          brand: [...state.brand, action.payload],
        }

      case UPDATE_SUBSUBCATEGORY_SUCCESS:
        return {
          ...state,
          productSubSubCategory: state.productSubSubCategory.map(x =>
            x.ID.toString() === action.payload.ID.toString()
              ? { x, ...action.payload }
              : x
          ),
        }
      

      case ADD_SUBSUBCATEGORY_SUCCESS:
        return {
          ...state,
          productSubSubCategory: [...state.productSubSubCategory, action.payload],
        }
  

      case GET_PRODUCTSUBSUBCATEGORY_SUCCESS:
        return {
          ...state,
          productSubSubCategory: action.payload,
        }


      case UPDATE_BRAND_SUCCESS:
        return {
          ...state,
          brand: state.brand.map(x =>
            x.ID.toString() === action.payload.ID.toString()
              ? { x, ...action.payload }
              : x
          ),
        }
  

      case GET_BRAND_SUCCESS:
        return {
          ...state,
          brand: action.payload,
        }

    case GET_POPUP_SUCCESS:
      return {
        ...state,
        popup: action.payload,
      }

    case GET_USERS_SUCCESS:
      return {
        ...state,
        users: action.payload,
      }

    case GET_USERS_FAIL:
      return {
        ...state,
        error: action.payload,
      }


    case ADD_REFERANCES_SUCCESS:
      return {
        ...state,
        referances: [...state.referances, action.payload],
      }

    case ADD_PRODUCTCATEGORY_SUCCESS:
      return {
        ...state,
        productCategory: [...state.productCategory, action.payload],
      }

    case ADD_BLOG_SUCCESS:
      return {
        ...state,
        blogs: [...state.blogs, action.payload],
      }
    case ADD_USER_SUCCESS:

      return {
        ...state,
        users: [...state.users, action.payload],
      }

    case UPDATE_USER_SUCCESS:
      return {
        ...state,
        forum: state.forum.map(x =>
          x.ID.toString() === action.payload.ID.toString()
            ? { x, ...action.payload }
            : x
        ),
      }

    case ADD_USER_FAIL:
      return {
        ...state,
        error: action.payload,
      }

    case GET_USER_PROFILE_SUCCESS:
      return {
        ...state,
        userProfile: action.payload,
      }



    case UPDATE_USER_FAIL:
      return {
        ...state,
        error: action.payload,
      }



    case DELETE_USER_FAIL:
      return {
        ...state,
        error: action.payload,
      }


    case GET_USER_PROFILE_FAIL:
      return {
        ...state,
        error: action.payload,
      }

    default:
      return state
  }
}

export default contacts
